import type { IFilterableListItem, IOmit, ISelectProps } from '@sixui/ui';
import { forwardRef, useCallback } from 'react';
import { Select } from '@sixui/ui';
import { useTranslation } from 'react-i18next';
import { useLocalStorage } from 'usehooks-ts';

export type ILanguageSelectorProps = IOmit<
  ISelectProps,
  'items' | 'value' | 'defaultValue' | 'onChange'
>;

export const LanguageSelector = forwardRef<
  HTMLDivElement,
  ILanguageSelectorProps
>(function LanguageSelector(props, forwardedRef) {
  const { ...other } = props;
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useLocalStorage<string>(
    '@@crowdaa@@::i18nextLng',
    'en',
    {
      initializeWithValue: true,
      serializer: (value) => value,
      deserializer: (value) => value,
    },
  );

  const handleChange = useCallback(
    (value = 'en') => {
      setLanguage(value);
      void i18n.changeLanguage(value);
    },
    [i18n, setLanguage],
  );
  const items: Array<IFilterableListItem> = [
    {
      value: 'en',
      label: t('common.english'),
    },
    {
      value: 'fr',
      label: t('common.french'),
    },
  ];

  return (
    <Select
      variant="outlined"
      {...other}
      items={items}
      value={language}
      onChange={handleChange}
      ref={forwardedRef}
    />
  );
});
